var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloadingdrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.41421 5C3.52331 5 3.07714 6.07714 3.70711 6.70711L6.29289 9.29289C6.68342 9.68342 7.31658 9.68342 7.70711 9.29289L10.2929 6.70711C10.9229 6.07714 10.4767 5 9.58579 5H4.41421Z",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloadingdrop);
export default __webpack_public_path__ + "static/media/floadingdrop.d89169db25a58a9915021f927fbf5ff2.svg";
export { ForwardRef as ReactComponent };